"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Upload = void 0;
var React = __importStar(require("react"));
var bind_1 = __importDefault(require("classnames/bind"));
var styles = __importStar(require("./styles.modules.css"));
var icon_1 = require("../icon");
var attachment_1 = __importDefault(require("./attachment"));
var text_1 = require("../text");
var thumbnail_1 = __importDefault(require("./thumbnail"));
var react_dropzone_1 = require("react-dropzone");
var cx = bind_1.default.bind(styles);
var defaultProps = {
    multiple: false,
    showFileList: false,
    showPreview: true,
    acceptedTypes: "image/jpeg, image/png",
};
var Upload = function (props) {
    var _a;
    var message = props.message, className = props.className, onChange = props.onChange, name = props.name, multiple = props.multiple, showFileList = props.showFileList, showPreview = props.showPreview, acceptedTypes = props.acceptedTypes;
    var icon = props.icon, uploadComplete = props.uploadComplete;
    if (!icon) {
        icon = icon_1.Icons.Upload;
    }
    var _b = React.useState([]), files = _b[0], setFiles = _b[1];
    var _c = (0, react_dropzone_1.useDropzone)({
        accept: acceptedTypes,
        multiple: multiple,
        onDrop: function (acceptedFiles) {
            var allFiles = files.concat(acceptedFiles);
            uploadComplete = false;
            setFiles(allFiles.map(function (file) {
                var additional = {};
                if (file.type.indexOf("image") > -1) {
                    additional = {
                        preview: URL.createObjectURL(file),
                    };
                }
                return Object.assign(file, additional);
            }));
            onChange(name, multiple ? allFiles : allFiles[0]);
        },
    }), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps;
    if (uploadComplete && files.length > 0) {
        setFiles([]);
    }
    var className_ = cx((_a = {
            outer: true
        },
        _a[className] = className,
        _a.files = files.length,
        _a));
    var thumbs = showPreview &&
        files.map(function (file) {
            return React.createElement(thumbnail_1.default, { key: file.name, file: file });
        });
    var noFiles = (React.createElement(React.Fragment, null,
        React.createElement(icon_1.Icon, { icon: icon, className: styles.icon }),
        React.createElement(text_1.Text, null, message)));
    var fileList = showFileList && (React.createElement("div", { className: styles.filelist }, files.map(function (file) {
        return (React.createElement(attachment_1.default, { file: file, key: file.name, onRemove: function (file) {
                files.splice(files.indexOf(file), 1);
                setFiles(files);
                onChange(name, multiple ? files : file[0]);
            } }));
    })));
    if (showPreview) {
        React.useEffect(function () { return function () {
            files.forEach(function (file) { return URL.revokeObjectURL(file.preview); });
        }; }, [files]);
    }
    return (React.createElement("div", null,
        React.createElement("div", __assign({}, getRootProps({ className: className_ })),
            React.createElement("input", __assign({}, getInputProps())),
            React.createElement("div", { className: styles.inner }, files.length && thumbs ? thumbs : noFiles)),
        fileList));
};
exports.Upload = Upload;
Upload.defaultProps = defaultProps;
exports.default = Upload;
//# sourceMappingURL=upload.js.map